/**
 * Hidden road API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';

export interface HiddenRoadAccount {
  id?: number;
  accountId?: number;
  account?: Account;
  exchangeName?: string;
  exchangeAccountName?: string;
}
